import { render, staticRenderFns } from "./BulkPaymentDetails.vue?vue&type=template&id=1a5c544c&"
import script from "./BulkPaymentDetails.vue?vue&type=script&lang=js&"
export * from "./BulkPaymentDetails.vue?vue&type=script&lang=js&"
import style0 from "./BulkPaymentDetails.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports